import {
  FETCH_SCHOOL_ISIR_REC_INFO,
  FETCH_AVAILABLE_AID_YEARS,
  FETCH_SCHOOL,
  RESET_SCHOOL, 
  FETCH_SCHOOL_LOGO
} from "../actions/types";

const INITIAL_STATE = {
  schoolCode: 222222,
  schoolName: "Test University",
  school: {},
  schoolIsirRecInfo: {},
  aidYears: [2019]
};

 // eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SCHOOL:
      return { ...state, schoolCode: action.payload.code, schoolName: action.payload.name, school: action.payload }
    case FETCH_SCHOOL_ISIR_REC_INFO:
      return { ...state, schoolIsirRecInfo: action.payload };
    case FETCH_AVAILABLE_AID_YEARS:
      return { ...state, aidYears: action.payload };
    case FETCH_SCHOOL_LOGO:
      return { ...state, schoolLogo: action.payload };
    case RESET_SCHOOL:
      return {
        schoolCode: 222222,
        schoolName: "Test University",
        school: {},
        schoolIsirRecInfo: {},
        aidYears: [2019]
      }
    default:
      return state;
  }
};
